import {Fragment, useState} from 'react'
import {useForm} from 'react-hook-form'

import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import Email from '../../shared/Email'
import FormWrapper from '../../shared/FormWrapper'
import Modal from '../../shared/Modal'

const AddEmail = props => {
  const [showModal, setShowModal] = useState(false)
  const methods = useForm()
  const {errors} = methods.formState

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  const handleSubmit = ({email}) => {
    props.addEmail(email).then(response => {
      if (response.success) {
        methods.reset()
        setShowModal(false)
      } else {
        methods.setError('email', {type: 'server', message: response.message})
      }
    })
  }

  return (
    <Fragment>
      <Button className='add-email' fullWidth onClick={toggleModal} variant='outlined'>
        <Stack className='summary' component='span' sx={{flexDirection: 'row'}}>
          <Stack className='icon' component='span' sx={{justifyContent: 'center'}}>
            <AddIcon fontSize='large' />
          </Stack>
          <Stack className='details' component='span'>
            <Typography className='heading' component='span' variant='body1'>Add another email</Typography>
            <Typography className='content' component='span' variant='body2'>
              We'll send a 6-digit code to confirm it reaches you
            </Typography>
          </Stack>
        </Stack>
      </Button>
      <Modal
        maxWidth='sm'
        open={showModal}
        handleClose={toggleModal}
        buttonText='Close'
        subHeading="We'll send a 6-digit code to the address. It joins your account as a second address once you enter that code back here."
        title='Add an email address'>
        <FormWrapper methods={methods} handleSubmit={handleSubmit}>
          <Email error={!!errors.email} helperText={errors.email?.message} />
          <Button disabled={props.loading} type='submit' variant='contained'>Send code</Button>
        </FormWrapper>
      </Modal>
    </Fragment>
  )
}

AddEmail.propTypes = {
  addEmail: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default AddEmail
